import React from 'react';

// Keep width/height consistent with CommandingModeMenu.scss viewModeMenuIcon
// (this is duplicated to ensure the placeholder doesn't depend on the css)
const placeholderStyle = {
    width: 12,
    height: 12,
};

export function CommandingModeMenuPlaceholder(): JSX.Element {
    return <div style={placeholderStyle} />;
}
